<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.tabelaObm"
            ref="RkmDataTable"
            sort-by="medicamentoDescricao"
        >
            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="$refs.ModalMaterial.open(item.medicamentoId)"
                    authorize="store-cadastro-material"
                    color="primary"
                    small
                    title="Vincular material"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalLog.open(item.medicamentoId)"
                    color="info"
                    small
                    title="Log de operações"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalLog ref="ModalLog" />

        <ModalMaterial
            @saved="$refs.RkmDataTable.refresh()"
            ref="ModalMaterial"
        />
    </div>
</template>

<script>
// Components.
import ModalLog from './components/log/Modal'
import ModalMaterial from './components/material/Modal'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        ModalLog,
        ModalMaterial,
    },
    created() {
        this.repositories = {
            tabelaObm: this.getConectaSusRepository('parametrizacao.tabelaObm')
        }
    },
    data: () => ({
        fields: [
            {key: 'medicamentoCodigo', label: 'Código', name: 'integracao_bnafar_medicamento.codigo', searchable: true, sortable: true},
            {key: 'medicamentoDescricao', label: 'Descrição', name: 'integracao_bnafar_medicamento.descricao', searchable: true, sortable: true},
            {key: 'materialDescricao', label: 'Material', name: 'cadastro_material.descricao', searchable: true, sortable: true},
            {key: 'actions', label: 'Ações', class: 'col-min text-center'},
        ],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
    },
    mixins: [error, repository],
}
</script>